import { render } from "./PagesBackground.vue?vue&type=template&id=26071f2d&scoped=true"
import script from "./PagesBackground.vue?vue&type=script&lang=js"
export * from "./PagesBackground.vue?vue&type=script&lang=js"

import "./PagesBackground.vue?vue&type=style&index=0&id=26071f2d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26071f2d"

export default script